import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    data() {
        return {
            es_idx: '', //스타일
            r_content: '', //내용
            mb_no: '', //작성자
            updateReason: '', //관리자 수정 사유
            deletePartReviewFiles: [],
        }
    },
    validators: {
        es_idx: function (value) {
            return Validator.value(value)
                .required('스타일을 선택해주세요.')
        },
        r_content: function (value) {
            return Validator.value(value)
                .required('내용을 입력해주세요.')
                .custom(() => {
                    if(value.length < 20) {
                        return '20자 이상으로 입력해주세요.'
                    }
                })
        },
        mb_no: function (value) {
            return Validator.value(value)
        },
        updateReason: function (value) {
            return Validator.value(value)
                .required('내용을 입력해주세요.')
        },
    },
    methods: {},
    computed: {},
}
